function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelect } from "downshift";
import { useCallback, useState } from "react";
import { UnfoldLessOutlined, UnfoldMoreOutlined } from "sprout-ui-icons";
import { Box, Flex } from "sprout-ui-primitives";
import { themeGet } from "sprout-ui-theme";
import styled from "styled-components";
import { usePopper } from "react-popper";
import { Button } from "../Button";
import sameWidth from "../utils/sameWidth";
import { ScrollContainer } from "../ScrollContainer";
import maxHeight from "../utils/maxHeight";
import applyMaxHeight from "../utils/applyMaxHeight";
import Label from "./Label";
import Option from "./Option";
const SelectButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;

  height: 48px;
  width: 100%;
  padding: 0 12px 0 16px;

  border: 1px solid ${themeGet("colors.black.12")};
  border-radius: 8px;
  color: ${themeGet("colors.black.87")};
  background: ${themeGet("colors.white.100")};

  text-align: left;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const SelectMenuWrapper = styled(Box)`
  outline: 0;
`;
const SelectMenu = styled(ScrollContainer)`
  box-shadow: 0 3px 6px ${themeGet("colors.black.16")};
  z-index: 1;
`;
const Select = (props)=>{
    const { label , options , value , onChange  } = props;
    const handleChange = useCallback((changes)=>{
        const { selectedItem  } = changes;
        if (selectedItem) onChange(selectedItem.value);
    }, [
        onChange
    ]);
    const { isOpen , getLabelProps , getToggleButtonProps , getMenuProps , getItemProps ,  } = useSelect({
        onSelectedItemChange: handleChange,
        initialSelectedItem: options.find((option)=>option.value === value),
        initialHighlightedIndex: options.findIndex((option)=>option.value === value),
        circularNavigation: true,
        items: options
    });
    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);
    const { styles  } = usePopper(referenceElement, popperElement, {
        placement: "bottom-start",
        modifiers: [
            sameWidth,
            maxHeight,
            applyMaxHeight
        ]
    });
    const matchingOption = options.find((option)=>option.value === value);
    var ref;
    const buttonLabel = (ref = matchingOption === null || matchingOption === void 0 ? void 0 : matchingOption.label) !== null && ref !== void 0 ? ref : "Select an option...";
    return /*#__PURE__*/ _jsxs(Box, {
        width: "100%",
        children: [
            label && /*#__PURE__*/ _jsx(Box, {
                mb: "8px",
                children: /*#__PURE__*/ _jsx(Label, _objectSpread({}, getLabelProps(), {
                    children: label
                }))
            }),
            /*#__PURE__*/ _jsxs(SelectButton, _objectSpread({
                type: "button"
            }, getToggleButtonProps({
                ref: setReferenceElement
            }), {
                children: [
                    buttonLabel,
                    /*#__PURE__*/ _jsx(Flex, {
                        as: "span",
                        color: "black.60",
                        children: !isOpen ? /*#__PURE__*/ _jsx(UnfoldMoreOutlined, {}) : /*#__PURE__*/ _jsx(UnfoldLessOutlined, {})
                    })
                ]
            })),
            /*#__PURE__*/ _jsx(SelectMenuWrapper, _objectSpread({}, getMenuProps(), {
                children: isOpen && /*#__PURE__*/ _jsx(SelectMenu, {
                    bg: "white.100",
                    p: "8px",
                    borderRadius: "8px",
                    ref: setPopperElement,
                    style: styles.popper,
                    children: options.map((option, index)=>/*#__PURE__*/ _jsx(Option, _objectSpread({}, option, getItemProps({
                            disabled: option.disabled,
                            item: option,
                            index
                        })), option.value))
                })
            }))
        ]
    });
};
export default Select;
